import { PromotionCodeForm } from './PromotionCodeForm'
import { withPromotionCodeForm } from './withPromotionCodeForm'

const ConnectedPromotionCodeForm = withPromotionCodeForm(PromotionCodeForm)

export { ConnectedPromotionCodeForm as PromotionCodeForm }
